import ArrowIcon from '@images/icons/breadcrumb-arrow.svg?react'
import cn from 'classnames'
import { useHistory, useLocation } from 'react-router-dom'

import styles from './Breadcrumb.module.scss'

type BreadcrumbProps = {
  items: { label: string; path: (id?: string) => string }[]
}

export const Breadcrumb = ({ items }: BreadcrumbProps) => {
  const history = useHistory()
  const location = useLocation()

  const parts = location?.pathname?.split('/') // Split the string by '/'
  const param = parts[parts?.length - 1] || ''

  const handleClick = (path, param) => {
    if (path(param) === 'back') {
      history.goBack()
    } else {
      history.push(path(param))
    }
  }

  return (
    <div className={cn(styles['breadcrumb-wrapper'], 'breadcrumb')}>
      {items.map(({ label, path }) => (
        <div key={label} className={cn(styles['breadcrumb-item'], 'breadcrumb-item')}>
          <span
            className={cn('label', { active: path(param) === location.pathname })}
            onClick={() => handleClick(path, param)}
            data-test={`breadcrumb-item-${label}`}
          >
            {label}
          </span>
          <span className='icon'>
            <ArrowIcon />
          </span>
        </div>
      ))}
    </div>
  )
}
